import { render, staticRenderFns } from "./Witnesses.vue?vue&type=template&id=429450ca&"
import script from "./Witnesses.vue?vue&type=script&lang=js&"
export * from "./Witnesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports